import { cn, ProductBadge } from '@yanolja-rnd/nol-design-system'
import React from 'react'
import { isTruthy } from '~/app/utils'

const DateTimeInfo = ({ label, date, time }: { label: string; date: string; time: string }) => {
  return (
    <div className={'text-center'}>
      <div className={'mb-6 typography-body-12-regular pf-pc:typography-body-14-regular'}>
        {label}
      </div>
      <div className={'mb-2 typography-body-14-bold pf-pc:typography-subtitle-16-bold'}>{date}</div>
      <div className={'typography-body-14-bold pf-pc:typography-subtitle-16-bold'}>{time}</div>
    </div>
  )
}

type Props = {
  checkInDate: string
  checkInTime: string
  checkOutDate: string
  checkOutTime: string
  useTimeText: string
  children?: React.ReactNode
  className?: string
  hasDivider?: boolean
}

/**
 * 장바구니, 국내/해외 주문서, 예약상세 > 숙소 상품 > 체크인/아웃 정보
 * - 체크인 날짜+시간
 * - 체크아웃 날짜+시간
 * - 박수 or 이용 시간
 * - 하단 추가 정보
 */
const PropertyCheckInOutInfo = (props: Props) => {
  const {
    className,
    checkInDate,
    checkInTime,
    checkOutDate,
    checkOutTime,
    useTimeText,
    children,
    hasDivider = false,
  } = props

  const hasChildren = React.Children.toArray(children).filter(isTruthy).length > 0

  return (
    <div
      className={cn(
        'grid grid-cols-[1fr_auto_1fr] items-center gap-x-8 rounded-12 bg-fill-neutral-weak p-16',
        className
      )}
    >
      <DateTimeInfo label="체크인" date={checkInDate} time={checkInTime} />
      <ProductBadge type="outlined_primary" size="large">
        {useTimeText}
      </ProductBadge>
      <DateTimeInfo label="체크아웃" date={checkOutDate} time={checkOutTime} />

      {hasDivider && (
        <div className="col-start-1 col-end-4 mt-8 border-t border-dashed border-line-neutral-weak3" />
      )}

      {hasChildren && <div className="col-start-1 col-end-4 mt-16">{children}</div>}
    </div>
  )
}

export default PropertyCheckInOutInfo
